webpackJsonp([47638219804947],{

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.genericPageQuery = exports.GenericPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Content = __webpack_require__(22);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(34);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _banner = __webpack_require__(51);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GenericPageTemplate = exports.GenericPageTemplate = function GenericPageTemplate(_ref) {
	    var title = _ref.title,
	        content = _ref.content,
	        contentComponent = _ref.contentComponent,
	        siteTitle = _ref.siteTitle,
	        siteUrl = _ref.siteUrl,
	        preview = _ref.preview;
	
	    var PageContent = contentComponent || _Content2.default;
	
	    siteTitle = siteTitle || '';
	    siteUrl = siteUrl || '';
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                siteTitle + ' - ' + title
	            ),
	            _react2.default.createElement('link', { rel: 'alternate', href: siteUrl, hrefLang: 'it-it' }),
	            _react2.default.createElement('meta', { name: 'description', content: title + ' - ' + siteTitle }),
	            _react2.default.createElement('meta', { name: 'image', content: _banner2.default }),
	            _react2.default.createElement('meta', { property: 'og:url', content: siteUrl }),
	            _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	            _react2.default.createElement('meta', { property: 'og:title', content: title + ' - ' + siteTitle }),
	            _react2.default.createElement('meta', { property: 'og:description', content: title + ' - ' + siteTitle }),
	            _react2.default.createElement('meta', { property: 'og:image', content: _banner2.default }),
	            _react2.default.createElement('meta', { name: 'twitter:title', content: title + ' - ' + siteTitle }),
	            _react2.default.createElement('meta', { name: 'twitter:description', content: title + ' - ' + siteTitle }),
	            _react2.default.createElement('meta', { name: 'twitter:image', content: _banner2.default })
	        ),
	        _react2.default.createElement(_BannerLanding2.default, { title: title, preview: preview }),
	        _react2.default.createElement(
	            'div',
	            { id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(PageContent, { className: 'inner', content: content })
	            )
	        )
	    );
	};
	
	GenericPageTemplate.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    content: _propTypes2.default.string,
	    contentComponent: _propTypes2.default.func,
	    siteTitle: _propTypes2.default.string,
	    siteUrl: _propTypes2.default.string,
	    preview: _propTypes2.default.bool
	};
	
	var GenericPage = function GenericPage(_ref2) {
	    var _ref2$data = _ref2.data,
	        site = _ref2$data.site,
	        genericPage = _ref2$data.genericPage;
	
	    var siteTitle = site.siteMetadata.title;
	    var siteUrl = site.siteMetadata.siteUrl + genericPage.fields.slug;
	
	    return _react2.default.createElement(GenericPageTemplate, {
	        contentComponent: _Content.HTMLContent,
	        title: genericPage.frontmatter.title,
	        content: genericPage.html,
	        siteTitle: siteTitle,
	        siteUrl: siteUrl
	    });
	};
	
	GenericPage.propTypes = {
	    data: _propTypes2.default.object.isRequired
	};
	
	exports.default = GenericPage;
	var genericPageQuery = exports.genericPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-generic-page-js-ac5ecd5cfad08a8e17d0.js